import React from 'react';
import Modal from 'react-modal';

import modal from '../../../definitions/Modal';

import Row from '../../tag/Row';
import Span from '../../tag/Span';
import OTButton from '../../tag/OTButton';
import { FormattedMessage } from 'react-intl';
import OTButtonGroup from '../../tag/OTButtonGroup';

const style = modal({ content: { width: '400px' } });

let { id: module_id } = module;

const NavigateToQuestionnaireModal = ({
  isOpen,
  hideModal,
  data,
  goToOmavointi,
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={hideModal}
        style={style}
        contentLabel=""
      >
        <Row style={{ marginBottom: '40px' }}>
          <Span>
            <h4 className="float-left ot-modal__title">
              <FormattedMessage id={`${module_id}.title`} />
            </h4>
          </Span>
        </Row>
        <Row>
          <OTButtonGroup type={'big'} fullWidth collapseOnMobile>
            <OTButton color={'gray'} onClick={hideModal} message={'cancel'} />
            <OTButton
              onClick={() => {
                let newWindow = window.open('', '_blank');

                goToOmavointi(newWindow, data.formCode, data.formId);
              }}
              message={'continue'}
            />
          </OTButtonGroup>
        </Row>
      </Modal>
    </>
  );
};

Modal.setAppElement('body');
export default NavigateToQuestionnaireModal;
